import { useEffect, useState } from 'react';
import {
  persistSelectedStyles,
  readPersistedSelectedStyles,
  SelectedStyles,
  withSelectedStyle,
} from './selection';
import { getStyleById, ProductKey } from './style-definitions';

type Listener = (nextState: SelectedStyles) => void;

const listeners = new Set<Listener>();
let storeState = readPersistedSelectedStyles();

function notify() {
  listeners.forEach((listener) => listener(storeState));
}

export function getSelectedStyles(): SelectedStyles {
  return storeState;
}

export function setSelectedStyle(product: ProductKey, styleId: string) {
  const nextState = withSelectedStyle(storeState, product, styleId);

  if (
    nextState.projectManagerApp === storeState.projectManagerApp &&
    nextState.checkInPlatform === storeState.checkInPlatform
  ) {
    return;
  }

  storeState = nextState;
  persistSelectedStyles(storeState);
  notify();
}

export function useStyleStore() {
  const [selectedStyles, setSelectedStylesState] = useState<SelectedStyles>(storeState);

  useEffect(() => {
    storeState = readPersistedSelectedStyles();
    setSelectedStylesState(storeState);

    const listener: Listener = (nextState) => {
      setSelectedStylesState(nextState);
    };

    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return {
    selectedStyles,
    activeStyles: {
      projectManagerApp: getStyleById(selectedStyles.projectManagerApp),
      checkInPlatform: getStyleById(selectedStyles.checkInPlatform),
    },
    setSelectedStyle,
  };
}
